module.exports = __webpack_public_path__ + "img/IMG-20191208-WA0065.a0921e23.jpg";